(() => {
  if (customElements.get('featured-collections')) {
    return;
  }

  class FeaturedCollections extends HTMLElement {
    constructor() {
      super();
      this.setLinks = this.setLinks.bind(this);
      this.sliderNavItemsChange = this.sliderNavItemsChange.bind(this);
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.init();
        this.initNavItemsSlider();
        this.initImagesSlider();
        this.attachEvents();

        const firstLink = Array.from(this.links).find(
          (link) => link.dataset.index == 1,
        );
        this.onChangeActiveLink(firstLink);
        this.addVisibleClass();
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px -40% 0px',
      }).observe(this);
    }

    init() {
      this.mobileBreakpoint = '(max-width: 989px)';
      this.sliderNavItems = null;
      this.sliderImages = null;
      this.sliderNavItemsChangeFromSliderImages = false;
      this.sliderImagesChangeFromSliderNavItems = false;
      this.links = this.querySelectorAll('[data-link]');
      this.image = this.querySelector('[data-image]');
      this.button = this.querySelector('[data-button]');
    }

    attachEvents() {
      window.addEventListener('resize', this.initNavItemsSlider.bind(this));
      window.addEventListener('resize', this.initImagesSlider.bind(this));

      this.links.forEach((link) => {
        link.addEventListener('mouseenter', (event) => {
          const isMobileDevices = window.matchMedia(
            this.mobileBreakpoint,
          ).matches;

          if (!isMobileDevices) {
            this.onChangeActiveLink(event.target);
          }
        });
      });
    }

    initNavItemsSlider() {
      const isMobileDevices = window.matchMedia(this.mobileBreakpoint).matches;

      if (this.sliderNavItems && !isMobileDevices) {
        this.destroySliderNavItems();
      }

      if (
        !this.querySelector('[data-slider]') ||
        this.sliderNavItems ||
        !isMobileDevices
      ) {
        return;
      }

      this.sliderNavItems = new Swiper(this.querySelector('[data-slider]'), {
        init: false,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
      });

      this.sliderNavItems.on('init', this.setLinks);

      this.sliderNavItems.init();

      this.sliderNavItems.on('loopFix', this.setLinks);

      this.sliderNavItems.on('realIndexChange', this.sliderNavItemsChange);
    }

    initImagesSlider() {
      if (!this.querySelector('[data-images-slider]') || this.sliderImages) {
        return;
      }

      this.sliderImages = new Swiper(
        this.querySelector('[data-images-slider]'),
        {
          slidesPerView: 1,
          loop: true,
          effect: 'fade',
        },
      );

      this.sliderImages.on('realIndexChange', () => {
        if (!this.sliderImagesChangeFromSliderNavItems && this.sliderNavItems) {
          this.sliderNavItemsChangeFromSliderImages = true;

          this.sliderNavItems.slideToLoop(this.sliderImages.realIndex);
        }

        this.sliderImagesChangeFromSliderNavItems = false;
      });
    }

    destroySliderNavItems() {
      this.sliderNavItems.destroy();

      this.sliderNavItems = null;
    }

    setLinks() {
      this.links = this.querySelectorAll('[data-link]');
    }

    sliderNavItemsChange() {
      const activeSlide =
        this.sliderNavItems.slides[this.sliderNavItems.activeIndex];
      const currentLink = activeSlide.querySelector('[data-link]');

      this.changeActiveLink(currentLink);
      this.updateButton(currentLink.dataset.title, currentLink.href);

      if (!this.sliderNavItemsChangeFromSliderImages) {
        this.sliderImagesChangeFromSliderNavItems = true;

        this.changeImage(this.sliderNavItems.realIndex);
      }

      this.sliderNavItemsChangeFromSliderImages = false;
    }

    onChangeActiveLink(currentLink) {
      if (currentLink.classList.contains('is-current')) {
        return;
      }

      this.changeActiveLink(currentLink);
      this.updateButton(currentLink.dataset.title, currentLink.href);
      this.changeImage(currentLink.dataset.index - 1);
    }

    changeActiveLink(currentLink) {
      this.links.forEach((link) =>
        link.classList.toggle('is-current', link === currentLink),
      );
    }

    changeImage(index) {
      this.sliderImages.slideToLoop(Number(index));
    }

    updateButton(title, url) {
      if (!this.button) {
        return;
      }

      if (title) {
        this.button.querySelector('[data-title-container]').textContent = title;
      }

      if (url) {
        this.button.href = url;
      }
    }

    addVisibleClass() {
      this.classList.add('is-visible');
    }
  }

  customElements.define('featured-collections', FeaturedCollections);
})();
